import React, { useState, useEffect, useRef, useCallback } from 'react';
import styled, { keyframes } from 'styled-components';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject$3, _templateObject2$3, _templateObject3$2, _templateObject4$1, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22;
var CarouselCntWrp = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n"])));
var CarouselCont = styled.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n    margin: 0 auto;\n    overflow: hidden;\n    width: 100%;\n    border-radius: 16px;\n"])));
var CarouselSlider = styled.div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteralLoose(["\n    white-space: nowrap;\n    width: 100%;\n    transform: ", ";\n    transition: ease 1000ms;\n"])), function (props) {
  return props.translate ? "translate(" + props.translate + "%)" : "#fff";
});
var CarouselElmnt = styled.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    height: 260px;\n    width: 100%;\n    border-radius: 16px;\n    background-color: ", ";\n"])), function (props) {
  return props.bgColor ? props.bgColor : "#fff";
});
var SlideShowDotsCnt = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-self: center;\n"])));
var SlideShowDot = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n    height: 10px;\n    width: 10px;\n    border-radius: 50%;\n    cursor: pointer;\n    margin: 12px 4px 0px;\n    background-color: ", ";\n"])), function (props) {
  return props.isActive ? "#2276E3" : "#c4c4c4";
});
var LeftArwBtn = styled.button(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    left: 14px;\n    border: none;\n    outline: none;\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background-color: rgba(20, 24, 35,0.2);\n    cursor: pointer;\n\n    &:after {\n        display: block;\n        content: '';\n        width: 10px;\n        height: 10px;\n        border-left: 2px solid #fff;\n        border-top: 2px solid #fff;\n        transform: rotate(-45deg);\n    }\n"])));
var RightArwBtn = styled.button(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    right: 14px;\n    border: none;\n    outline: none;\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background-color: rgba(20, 24, 35,0.2);\n    cursor: pointer;\n\n    &:after {\n        display: block;\n        content: '';\n        width: 10px;\n        height: 10px;\n        border-right: 2px solid #fff;\n        border-top: 2px solid #fff;\n        transform: rotate(45deg);\n    }\n"])));
var shine = keyframes(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n  0% {\n    background-position: -468px 0;\n  }\n  \n  100% {\n    background-position: 468px 0; \n  }\n"])));
var Placeholder = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n  width: 1132px;\n  height: 260px;\n  border-radius: 16px;\n  margin: 0;\n  background: #E1E7EE;\n  background-image: linear-gradient(to right, #E1E7EE 0%, #E1E7EE 20%, #E1E7EE 40%, #E1E7EE 100%);\n  background-repeat: no-repeat;\n  background-size: 800px 400px; \n  display: inline-block;\n  position: relative; \n  animation: ", " 1s linear infinite;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n"])), shine);
var rolling = keyframes(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n  from {\n    left: -75px;\n  }\n  to{\n    left: 100%;\n  }\n"])));
var LineCont = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 150px;\n  height: 4px;\n  background-color: #C4C4C4;\n  position: relative;\n  overflow: hidden;\n"])));
var LineContInner = styled.span(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  width: 75px;\n  height: 4px;\n  background-color: #2276E3;\n  position: relative;\n  animation: ", " 1s linear infinite;\n"])), rolling);
var CarouselImgBg = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteralLoose(["\n    height: 100%;\n    padding: 0px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n"])));
styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n"])));
styled.p(_templateObject16 || (_templateObject16 = _taggedTemplateLiteralLoose(["\n    padding: 10px 12px;\n    border-radius: 8px;\n    background-color: rgba(0,0,0,0.5);\n    font-family: ", ";\n    font-weight: bold;\n    font-size: 18px;\n    line-height: 22px;\n    color: #FFFFFF;\n    align-self: flex-start;\n"])), function (props) {
  return props.theme.font.fontFamilyQuicksand;
});
styled.p(_templateObject17 || (_templateObject17 = _taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 30px;\n    line-height: 37px;\n    color: #FFFFFF;\n    margin-top: 17px;\n"])), function (props) {
  return props.theme.font.fontFamilyQuicksand;
});
styled.span(_templateObject18 || (_templateObject18 = _taggedTemplateLiteralLoose(["\n    font-weight: bold;\n"])));
styled.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteralLoose(["\n    background-color: #fff;\n    border-radius: 4px;\n    width: 200px;\n    height: 46px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 27px;\n"])));
styled.img(_templateObject20 || (_templateObject20 = _taggedTemplateLiteralLoose(["\n    width: 112px;\n    height: 30px;\n"])));
var MainDealImg = styled.img(_templateObject21 || (_templateObject21 = _taggedTemplateLiteralLoose(["\n    height: 100%;\n    width: 100%;\n    align-self: flex-end;\n"])));
var Container$1 = styled.section(_templateObject22 || (_templateObject22 = _taggedTemplateLiteralLoose(["\n    width: 1132px;\n    height: 260px;\n    margin: 0 auto;\n"])));

var CarousalShimmer = function CarousalShimmer() {
  return /*#__PURE__*/React.createElement(LineCont, null, /*#__PURE__*/React.createElement(LineContInner, null));
};

var CarouselmgPlaceholder = function CarouselmgPlaceholder(_ref) {
  var imageUrl = _ref.imageUrl,
      link = _ref.link;
  return /*#__PURE__*/React.createElement(CarouselImgBg, null, /*#__PURE__*/React.createElement("a", {
    href: link
  }, /*#__PURE__*/React.createElement(MainDealImg, {
    alt: "main icon",
    src: imageUrl
  })));
};

/* eslint-disable react/no-array-index-key */
var Carousel = function Carousel(props) {
  var _props$bannerData = props.bannerData,
      bannerData = _props$bannerData === void 0 ? [] : _props$bannerData,
      _props$delay = props.delay,
      delay = _props$delay === void 0 ? 2 : _props$delay,
      _props$selectedIndex = props.selectedIndex,
      selectedIndex = _props$selectedIndex === void 0 ? 0 : _props$selectedIndex,
      onLoad = props.onLoad,
      onBannerClick = props.onBannerClick,
      onChevronClick = props.onChevronClick;

  var _useState = useState((bannerData == null ? void 0 : bannerData.length) === 0),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = useState(selectedIndex || 0),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var crslElLst = bannerData.map(function (item, indx) {
    return /*#__PURE__*/React.createElement(CarouselElmnt, {
      key: "klko" + indx,
      onClick: function onClick() {
        return onBannerClick(indx, item == null ? void 0 : item.url);
      }
    }, /*#__PURE__*/React.createElement(CarouselmgPlaceholder, {
      imageUrl: item.imgUrl,
      link: item == null ? void 0 : item.url
    }));
  });

  var updateActiveIndex = function updateActiveIndex(indx) {
    if (!bannerData.length) {
      return;
    }

    if (indx === bannerData.length) setActiveIndex(0);else if (indx < 0) setActiveIndex(bannerData.length - 1);else setActiveIndex(indx);
  };

  var onLeftArrowClick = function onLeftArrowClick(currentIndex) {
    onChevronClick('left', currentIndex - 1);
    updateActiveIndex(currentIndex - 1);
  };

  var onRightArrowClick = function onRightArrowClick(currentIndex) {
    onChevronClick('right', currentIndex + 1);
    updateActiveIndex(currentIndex + 1);
  };

  var onBottomChevronClick = function onBottomChevronClick(index) {
    onChevronClick('bottom', index);
    updateActiveIndex(index);
  };

  var dotsElLst = bannerData.map(function (_, indx) {
    return /*#__PURE__*/React.createElement(SlideShowDot, {
      key: "klko" + indx,
      isActive: indx === activeIndex,
      onClick: function onClick() {
        return onBottomChevronClick(indx);
      }
    });
  });
  useEffect(function () {
    onLoad();
  }, []);
  useEffect(function () {
    if (bannerData.length) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, [bannerData]);
  useEffect(function () {
    setActiveIndex(selectedIndex);
  }, [selectedIndex]);
  useEffect(function () {
    if (!bannerData.length) {
      return function () {};
    }

    var timer = setTimeout(function () {
      if (activeIndex === bannerData.length - 1) setActiveIndex(0);else setActiveIndex(function (indx) {
        return indx + 1;
      });
    }, delay * 1000);
    return function () {
      return clearTimeout(timer);
    };
  }, [activeIndex, bannerData, delay]);
  return /*#__PURE__*/React.createElement(Container$1, null, /*#__PURE__*/React.createElement(CarouselCntWrp, null, /*#__PURE__*/React.createElement(CarouselCont, null, /*#__PURE__*/React.createElement(CarouselSlider, {
    translate: -activeIndex * 100
  }, isLoading ? /*#__PURE__*/React.createElement(Placeholder, null, /*#__PURE__*/React.createElement(CarousalShimmer, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, crslElLst)), /*#__PURE__*/React.createElement(LeftArwBtn, {
    onClick: function onClick() {
      return onLeftArrowClick(activeIndex);
    }
  }), /*#__PURE__*/React.createElement(RightArwBtn, {
    onClick: function onClick() {
      return onRightArrowClick(activeIndex);
    }
  })), /*#__PURE__*/React.createElement(SlideShowDotsCnt, null, dotsElLst)));
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var _templateObject$2, _templateObject2$2, _templateObject3$1;
var OuterWrapper = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n"])));
var Wrapper = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n\toverflow: hidden;\n\tposition: relative;\n\tbackground-color: transparent;\n\tmax-width: 1200px;\n\tmargin-left: auto;\n\tmargin-right: auto;\n"])));
var Container = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n"])));

var _templateObject$1, _templateObject2$1, _templateObject3, _templateObject4;
var BtnWrapper = styled.button(function (props) {
  return "\n  position: absolute;\n  top: 36%;\n  padding: 8px 12px;\n  cursor: pointer;\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.25);\n  border: 1px solid #E1E7EE;\n  background-color: white;\n  transition: transform .2s;\n  :hover {\n    transform: scale(1.2);\n  }\n  ";
});
var LeftBtnWrapper = styled(BtnWrapper)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n\tdisplay: ", ";\n\tleft: 76px;\n\ttop: 35%;\n"])), function (props) {
  return props.show ? 'block' : 'none';
});
var RightBtnWrapper = styled(BtnWrapper)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n\tdisplay: ", ";\n\tmargin-left: auto;\n\tright: 76px;\n\ttop: 35%;\n"])), function (props) {
  return props.show ? 'block' : 'none';
});
var prevBtn = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\tbackground-image: url(\"data:image/svg+xml,%0A%3Csvg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M19.063 11.036H7.624a.168.168 0 0 1-.11-.292l5.774-5.081a.963.963 0 0 0-1.27-1.445l-7.475 6.577a1.604 1.604 0 0 0 0 2.407l7.473 6.575a.963.963 0 0 0 1.27-1.444l-5.773-5.08a.168.168 0 0 1 .11-.293h11.44a.963.963 0 0 0 0-1.925v.001Z' fill='%232276E3'/%3E%3C/svg%3E\");\n\tbackground-repeat: no-repeat;\n\tposition: relative;\n\tleft: 10px;\n\twidth: 24px;\n\theight: 24px;\n"])));
var NextBtn = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tbackground-image: url(\"data:image/svg+xml,%0A%3Csvg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.937 12.964h11.439a.168.168 0 0 1 .11.292l-5.774 5.081a.963.963 0 0 0 1.27 1.445l7.475-6.577a1.604 1.604 0 0 0 0-2.407l-7.473-6.575a.963.963 0 0 0-1.27 1.444l5.773 5.08a.168.168 0 0 1-.11.293H4.937a.963.963 0 0 0 0 1.925v-.001Z' fill='%232276E3'/%3E%3C/svg%3E\");\n\tbackground-repeat: no-repeat;\n\tposition: relative;\n\tleft: 10px;\n\twidth: 24px;\n\theight: 24px;\n"])));

var ButtonsWrapper = function ButtonsWrapper(_ref) {
  var scrollPrev = _ref.scrollPrev,
      scrollNext = _ref.scrollNext,
      prevBtnEnabled = _ref.prevBtnEnabled,
      nextBtnEnabled = _ref.nextBtnEnabled,
      leftNavBtnStyle = _ref.leftNavBtnStyle,
      rightNavBtnStyle = _ref.rightNavBtnStyle;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LeftBtnWrapper, {
    id: "c-l01",
    onClick: scrollPrev,
    show: prevBtnEnabled,
    style: _extends({}, leftNavBtnStyle),
    "aria-label": "prev scroll"
  }, /*#__PURE__*/React.createElement(prevBtn, null)), /*#__PURE__*/React.createElement(RightBtnWrapper, {
    id: "c-r02",
    onClick: scrollNext,
    show: nextBtnEnabled,
    style: _extends({}, rightNavBtnStyle),
    "aria-label": "next scroll"
  }, /*#__PURE__*/React.createElement(NextBtn, null)));
};

var _templateObject, _templateObject2;
var DotsWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tleft: 172px;\n\tleft: 50%;\n\tbottom: 30px;\n\ttransform: translateX(-50%);\n"])));
var DotWrapper = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\twidth: 7px;\n\theight: 7px;\n\tmargin-right: 7px;\n\tcursor: pointer;\n\tborder-radius: 50%;\n\tbox-shadow: inset 0px 0px 2.77778px rgba(0, 0, 0, 0.25);\n\tbackground: ", ";\n"])), function (props) {
  return props.active ? '#2276E3' : '#C4C4C4';
});

var Dots = function Dots(_ref) {
  var slides = _ref.slides,
      activeSlide = _ref.activeSlide,
      scrollToSlide = _ref.scrollToSlide,
      dotStyling = _ref.dotStyling;
  return /*#__PURE__*/React.createElement(DotsWrapper, {
    style: _extends({}, dotStyling)
  }, slides.map(function (slide, i) {
    return /*#__PURE__*/React.createElement(DotWrapper, {
      key: slide,
      active: activeSlide === i,
      onClick: function onClick() {
        return scrollToSlide(i);
      }
    });
  }));
};

Dots.defaultProps = {
  dotStyling: {}
};

var NewCaraousel = function NewCaraousel(_ref) {
  var children = _ref.children,
      leftNavBtnStyle = _ref.leftNavBtnStyle,
      rightNavBtnStyle = _ref.rightNavBtnStyle,
      slidesToScroll = _ref.slidesToScroll,
      slideStartMargin = _ref.slideStartMargin,
      reInit = _ref.reInit,
      scrollSpeed = _ref.scrollSpeed,
      skipScrollSnaps = _ref.skipScrollSnaps,
      onLoad = _ref.onLoad,
      onChevronClicked = _ref.onChevronClicked,
      align = _ref.align,
      isAutoPlay = _ref.isAutoPlay,
      wrapperStyling = _ref.wrapperStyling,
      showSideBtns = _ref.showSideBtns,
      showDots = _ref.showDots,
      dotStyling = _ref.dotStyling;
  var autoPlayInit = isAutoPlay ? Autoplay({
    delay: 3000,
    stopOnInteraction: false
  }) : null;
  var autoplay = useRef(autoPlayInit);
  var emblaPlugins = [];
  if (isAutoPlay) emblaPlugins.push(autoplay.current);

  var _useEmblaCarousel = useEmblaCarousel({
    slidesToScroll: slidesToScroll,
    // to go to a specific card index
    skipSnaps: skipScrollSnaps,
    // Allow the carousel to skip scroll snaps if it's dragged vigorously
    speed: scrollSpeed,
    // 10 is default scroll speed as per embla guidelines
    align: align // to align card in horizontal direction

  }, [].concat(emblaPlugins)),
      emblaRef = _useEmblaCarousel[0],
      emblaApi = _useEmblaCarousel[1];

  var _useState = useState(false),
      prevBtnEnabled = _useState[0],
      setPrevBtnEnabled = _useState[1];

  var _useState2 = useState(false),
      nextBtnEnabled = _useState2[0],
      setNextBtnEnabled = _useState2[1];

  var _useState3 = useState(0),
      selectedIndex = _useState3[0],
      setSelectedIndex = _useState3[1];

  var _useState4 = useState([]),
      scrollSlides = _useState4[0],
      setScrollSlides = _useState4[1];

  useEffect(function () {
    onLoad == null ? void 0 : onLoad();
  }, []);
  var onSelect = useCallback(function () {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
    setPrevBtnEnabled(emblaApi.canScrollPrev());
    setNextBtnEnabled(emblaApi.canScrollNext());
  }, [emblaApi, setSelectedIndex]);
  var scrollTo = useCallback(function (index) {
    if (!emblaApi) return;
    emblaApi.scrollTo(index);
    if (onChevronClicked) onChevronClicked(String(index));
  }, [emblaApi]);
  useEffect(function () {
    if (!emblaApi) return;
    setScrollSlides(emblaApi.scrollSnapList());
    emblaApi.on('select', onSelect);
    onSelect();
  }, [emblaApi, onSelect]);
  useEffect(function () {
    if (emblaApi) {
      emblaApi.reInit(); // update slide count on children change

      setScrollSlides(emblaApi.scrollSnapList());
      emblaApi.scrollTo(0, true);
      onSelect();
    }
  }, [emblaApi, reInit, children, onSelect]);

  var scrollPrev = function scrollPrev() {
    if (emblaApi) {
      var _autoplay$current;

      emblaApi.scrollPrev();
      if (isAutoPlay) autoplay == null ? void 0 : (_autoplay$current = autoplay.current) == null ? void 0 : _autoplay$current.reset();
      if (onChevronClicked) onChevronClicked('left');
    }
  };

  var scrollNext = function scrollNext() {
    if (emblaApi) {
      var _autoplay$current2;

      emblaApi.scrollNext();
      if (isAutoPlay) autoplay == null ? void 0 : (_autoplay$current2 = autoplay.current) == null ? void 0 : _autoplay$current2.reset();
      if (onChevronClicked) onChevronClicked('right');
    }
  };

  return /*#__PURE__*/React.createElement(OuterWrapper, null, /*#__PURE__*/React.createElement(Wrapper, {
    style: _extends({}, wrapperStyling),
    ref: emblaRef
  }, /*#__PURE__*/React.createElement(Container, {
    marginLeft: slideStartMargin
  }, children)), showSideBtns && /*#__PURE__*/React.createElement(ButtonsWrapper, {
    leftNavBtnStyle: leftNavBtnStyle,
    rightNavBtnStyle: rightNavBtnStyle,
    scrollPrev: scrollPrev,
    scrollNext: scrollNext,
    prevBtnEnabled: prevBtnEnabled,
    nextBtnEnabled: nextBtnEnabled
  }), showDots && /*#__PURE__*/React.createElement(Dots, {
    dotStyling: dotStyling,
    slides: scrollSlides,
    activeSlide: selectedIndex,
    scrollToSlide: function scrollToSlide(index) {
      return scrollTo(index);
    }
  }));
};

NewCaraousel.defaultProps = {
  slidesToScroll: 2,
  scrollSpeed: 5,
  skipScrollSnaps: true,
  slideStartMargin: '',
  align: 'start',
  isAutoPlay: false,
  leftNavBtnStyle: {},
  rightNavBtnStyle: {},
  onChevronClicked: undefined,
  reInit: undefined,
  onLoad: undefined,
  wrapperStyling: undefined,
  showSideBtns: true,
  showDots: false,
  dotStyling: {}
};

export { Carousel, NewCaraousel };
